/* istanbul ignore file */

export { CTABanner as default } from "./CTABanner";
